"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var base_types_1 = require("../../themes/base.types");
var utils_1 = require("../../utils");
var fillStyle = function (fill) {
    if (fill === 'horizontal') {
        return 'width: 100%;';
    }
    if (fill === 'vertical') {
        return 'height: 100%;';
    }
    if (fill) {
        return "\n      width: 100%;\n      height: 100%;\n    ";
    }
    return undefined;
};
var alignStyle = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  align-items: ", ";\n"], ["\n  align-items: ", ";\n"])), function (props) { return utils_1.ALIGN_ITEMS_MAP[props.align]; });
var alignContentStyle = styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  align-content: ", ";\n"], ["\n  align-content: ", ";\n"])), function (props) { return utils_1.ALIGN_CONTENT_MAP[props.alignContent]; });
var JUSTIFY_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var justifyStyle = styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  justify-items: ", ";\n"], ["\n  justify-items: ", ";\n"])), function (props) { return JUSTIFY_MAP[props.justify]; });
var JUSTIFY_CONTENT_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var justifyContentStyle = styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  justify-content: ", ";\n"], ["\n  justify-content: ", ";\n"])), function (props) { return JUSTIFY_CONTENT_MAP[props.justifyContent]; });
var gapStyle = function (props) {
    if (typeof props.gap === 'string') {
        var gapSize = props.theme.global.edgeSize[props.gap];
        return "grid-gap: " + gapSize + " " + gapSize + ";";
    }
    if (props.gap.row && props.gap.column) {
        return "\n      grid-row-gap: " + props.theme.global.edgeSize[props.gap.row] + ";\n      grid-column-gap: " + props.theme.global.edgeSize[props.gap.column] + ";\n    ";
    }
    if (props.gap.row) {
        return "\n      grid-row-gap: " + props.theme.global.edgeSize[props.gap.row] + ";\n    ";
    }
    if (props.gap.column) {
        return "\n      grid-column-gap: " + props.theme.global.edgeSize[props.gap.column] + ";\n    ";
    }
    return '';
};
var SIZE_MAP = {
    flex: '1fr',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var getRepeatCount = function (count) { return (typeof count === 'number' ? count : "auto-" + count); };
var getRepeatSize = function (size, theme) {
    return "minmax(" + ((base_types_1.SizeNameValues.includes(size) ? theme.global.size[size] : undefined) ||
        size) + ", 1fr)";
};
var sizeFor = function (size, props, isRow) {
    var mapped = SIZE_MAP[size];
    if (isRow && mapped && (!props.fillContainer || props.fillContainer === 'horizontal')) {
        console.warn('Grid needs `fill` when using fractional row sizes');
    }
    return mapped || props.theme.global.size[size] || size;
};
/**
 * This is an IE-Specific implementation of ensuring that columns are laid out correctly
 * if the count has been specified for the Grid.
 * @param props
 */
var ieColumnsStyle = function (props) {
    if (typeof props.columns === 'object') {
        var columns = [];
        for (var col = 0; col < props.columns.count; col++) {
            columns.push('1fr');
        }
        return styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      display: -ms-grid;\n      -ms-grid-columns: ", ";\n    "], ["\n      display: -ms-grid;\n      -ms-grid-columns: ", ";\n    "])), columns.join(' '));
    }
    // TODO: something for default size style
    return "";
};
var columnsStyle = function (props) {
    if (Array.isArray(props.columns)) {
        return styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      grid-template-columns: ", ";\n    "], ["\n      grid-template-columns: ",
            ";\n    "])), props.columns
            .map(function (s) {
            if (Array.isArray(s)) {
                return "minmax(" + sizeFor(s[0], props) + ", " + sizeFor(s[1], props) + ")";
            }
            return sizeFor(s, props);
        })
            .join(' '));
    }
    if (typeof props.columns === 'object') {
        return styled_components_1.css(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      grid-template-columns: repeat(\n        ", ",\n        ", "\n      );\n    "], ["\n      grid-template-columns: repeat(\n        ", ",\n        ", "\n      );\n    "])), getRepeatCount(props.columns.count), getRepeatSize(props.columns.size, props.theme));
    }
    return styled_components_1.css(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n    grid-template-columns: repeat(auto-fill, ", ");\n  "], ["\n    grid-template-columns: repeat(auto-fill, ", ");\n  "])), getRepeatSize(props.columns, props.theme));
};
var rowsStyle = function (props) {
    if (Array.isArray(props.rowsProp)) {
        return styled_components_1.css(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n      grid-template-rows: ", ";\n    "], ["\n      grid-template-rows: ",
            ";\n    "])), props.rowsProp
            .map(function (s) {
            if (Array.isArray(s)) {
                return "minmax(" + sizeFor(s[0], props, true) + ", " + sizeFor(s[1], props, true) + ")";
            }
            return sizeFor(s, props, true);
        })
            .join(' '));
    }
    return styled_components_1.css(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n    grid-auto-rows: ", ";\n  "], ["\n    grid-auto-rows: ", ";\n  "])), props.theme.global.size[props.rowsProp]);
};
var areasStyle = function (props) {
    // translate areas objects into grid-template-areas syntax
    if (!Array.isArray(props.rowsProp) || !Array.isArray(props.columns)) {
        console.warn('Grid `areas` requires `rows` and `columns` to be arrays.');
    }
    var cells = props.rowsProp.map(function () { return props.columns.map(function () { return '.'; }); });
    props.areas.forEach(function (area) {
        for (var row = area.start[1]; row <= area.end[1]; row += 1) {
            for (var column = area.start[0]; column <= area.end[0]; column += 1) {
                cells[row][column] = area.name;
            }
        }
    });
    return "grid-template-areas: " + cells.map(function (r) { return "\"" + r.join(' ') + "\""; }).join(' ') + ";";
};
exports.StyledGrid = styled_components_1.default.div(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  box-sizing: border-box;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n"], ["\n  display: grid;\n  box-sizing: border-box;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n"])), utils_1.genericStyles, function (props) { return props.fillContainer && fillStyle(props.fillContainer); }, function (props) { return props.align && alignStyle; }, function (props) { return props.alignContent && alignContentStyle; }, function (props) { return props.areas && areasStyle(props); }, function (props) { return props.columns && columnsStyle(props); }, function (props) { return props.gap && gapStyle(props); }, function (props) { return props.justify && justifyStyle; }, function (props) { return props.justifyContent && justifyContentStyle; }, function (props) { return props.rowsProp && rowsStyle(props); }, function (props) { return props.theme.grid && props.theme.grid.extend; }, function (props) { return !props.gridAvailable && ieColumnsStyle(props); });
/**
 * This style is specific to IE so that each Grid child
 * knows where to position itself on the grid.
 * The columnPosition and rowPosition are calculated at Grid.tsx
 */
exports.StyledGridChild = styled_components_1.default.div(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n  -ms-grid-column: ", "\n  -ms-grid-row: ", "\n"], ["\n  -ms-grid-column: ", "\n  -ms-grid-row: ", "\n"])), function (props) { return props.columnPosition; }, function (props) { return props.rowPosition; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
//# sourceMappingURL=StyledGrid.js.map